import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function DiscussYourCase() {
  return <section data-section-id="166949" id="handlungsaufforderung" className="bg-secondary text-secondary-foreground border-y border-slate-700/50 py-24 md:py-32 px-6 flex flex-col items-center justify-center text-center">
      <div className="max-w-2xl mx-auto flex flex-col items-center">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif text-white mb-10">
          Haben Sie Fragen zu unseren Bedingungen?
        </h2>
        <Button asChild className="rounded-[4px] border-none bg-primary text-primary-foreground hover:bg-background hover:text-white transition-all duration-300 font-mono text-[14px] tracking-[0.1em] h-auto py-4 px-8 uppercase focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-secondary shadow-inner">
          <Link to="/ContactPage">
            Kontaktieren Sie uns
          </Link>
        </Button>
      </div>
    </section>;
}